


export type BillHistoryStatus = 'Neutral' | 'Success' | 'Error';

export const BillHistoryStatus = {
    Neutral: 'Neutral' as BillHistoryStatus,
    Success: 'Success' as BillHistoryStatus,
    Error: 'Error' as BillHistoryStatus
};

